import type { ModalIbanAccountStep, QuizStepProps } from "@/features/user/quiz/types.ts";
import { useTranslation } from "react-i18next";
import { SectionTitleSmall } from "@/atoms-react/text/Text.react.tsx";
import InputLabel from "@/atoms-react/input/Input.react.tsx";
import DotsNavigation from "@/atoms-react/dots-navigation/DotsNavigation.react.tsx";
import { Button } from "@/atoms-react/button/Button.react.tsx";
import { Themes } from "@/types/theme.ts";

export const NatureProActivityStep = ({
  setStep,
  quizResponses,
  setQuizResponses,
  stepSettings,
  setPrevStep,
  totalSteps = 8
}: QuizStepProps) => {
  const { t } = useTranslation(["pass"]);
  const handleDescriptionChange = (selectedOption: string) => {
    if (/^\s/.test(selectedOption)) {
      selectedOption = "";
    }
    setQuizResponses?.((prev) => ({
      ...prev,
      natural_pro_activity: { ...prev.natural_pro_activity, description: selectedOption }
    }));
  };
  return (
    <>
      <SectionTitleSmall className="mt-2 mb-4 block">
        {t("olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.natural_pro_activity.question")}
      </SectionTitleSmall>
      <div className="mt-4 mb-4 flex min-w-full flex-col justify-center">
        <InputLabel
          autoFocus
          placeholder={t(
            "olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.natural_pro_activity.placeholder"
          )}
          rows={4}
          maxLength={40}
          required={true}
          className={"pb-4"}
          value={quizResponses?.natural_pro_activity?.description as string}
          onChange={(value: string) => handleDescriptionChange(value)}
        />
      </div>

      <div className="mt-auto mb-4 flex flex-col items-center">
        <DotsNavigation total={totalSteps} current={stepSettings.current} className="mb-4" />
        <div className="flex w-full flex-col-reverse gap-y-2 md:flex-row md:gap-x-2">
          <Button
            theme={Themes.white}
            onClick={() => setPrevStep(stepSettings.previous as ModalIbanAccountStep)}
          >
            {t("olkypass.general.go_back")}
          </Button>

          <Button
            disabled={
              quizResponses?.natural_pro_activity?.description == null ||
              quizResponses?.natural_pro_activity?.description == ""
            }
            onClick={() => setStep(stepSettings.next as ModalIbanAccountStep)}
          >
            {t("olkypass.general.continue")}
          </Button>
        </div>
      </div>
    </>
  );
};
